import UrlParams from '@nextgis/url-runtime-params';

import type { AppUrlParams } from '../interfaces';

export const urlParams = new UrlParams<AppUrlParams>();
